<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Go to Page" icon="▶" color="#2563eb">
        <label>Page</label>
        <select :value="props.data.pageTarget" @change="update('pageTarget', $event.target.value)">
            <option v-for="p in pageOptions" :key="p.value" :value="p.value">{{ p.label }}</option>
        </select>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { inject, computed } from 'vue';
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const haspObjects = inject('haspObjects', null);

const update = (key, val) => updateNodeData(props.id, { ...props.data, [key]: val });

const pageOptions = computed(() => {
    const pages = haspObjects?.pages?.value ?? [];
    return [
        { value: 'prev', label: '← Previous' },
        { value: 'next', label: '→ Next' },
        { value: 'back', label: '↩ Back' },
        ...pages.map(p => ({ value: String(p.id), label: p.label })),
    ];
});
</script>
